export const CONSENT_KEY = "noa.storage-consent.v1";
export const CONSENT_DURATION_MS = 180 * 24 * 60 * 60 * 1000;
export type StorageConsent = { version: 1; preferences: boolean; recordedAt: number };

export function parseConsent(raw: string | null, now = Date.now()): StorageConsent | null {
  try {
    const c = JSON.parse(raw ?? "null") as StorageConsent | null;
    return c?.version === 1 &&
      typeof c.preferences === "boolean" &&
      Number.isFinite(c.recordedAt) &&
      c.recordedAt <= now &&
      now - c.recordedAt < CONSENT_DURATION_MS
      ? c
      : null;
  } catch {
    return null;
  }
}
export function readStorageConsent() {
  try {
    const consent = parseConsent(localStorage.getItem(CONSENT_KEY));
    if (!consent?.preferences) localStorage.removeItem("i18nextLng");
    return consent;
  } catch {
    return null;
  }
}
export function saveStorageConsent(preferences: boolean) {
  const consent: StorageConsent = { version: 1, preferences, recordedAt: Date.now() };
  try {
    localStorage.setItem(CONSENT_KEY, JSON.stringify(consent));
    if (!preferences) localStorage.removeItem("i18nextLng");
  } catch {
    /* Le choix reste utilisable dans cette page si le stockage est indisponible. */
  }
  window.dispatchEvent(new CustomEvent("noa:consent-changed", { detail: consent }));
  return consent;
}
